import { styled } from '@linaria/react';
import type { AgentMinerSession } from '../../../../api/agent-miner-client/agent-miner-client.type';
import { inkDark, inkLight, inkLighter, skyDark } from '../../../../styles/design-tokens';
import { fmtNum } from '../../shared/formatters';

type TokensCellProps = {
  session: AgentMinerSession;
};

export function TokensCell({ session }: TokensCellProps) {
  const inTokens = session.total_input_tokens ?? 0;
  const outTokens = session.total_output_tokens ?? 0;
  const cacheTokens = (session.total_cache_creation_tokens ?? 0) + (session.total_cache_read_tokens ?? 0);
  const total = inTokens + outTokens + cacheTokens;

  if (total === 0) return <Dash>—</Dash>;

  return (
    <NumberText>
      {fmtNum(inTokens)}
      <Divider> / </Divider>
      {fmtNum(outTokens)}
      <Divider> / </Divider>
      <CacheNumber>{fmtNum(cacheTokens)}</CacheNumber>
    </NumberText>
  );
}

const NumberText = styled.span`
  font-family: 'SF Mono', ui-monospace, Menlo, monospace;
  font-weight: 500;
  font-size: 11px;
  line-height: 1;
  color: ${inkDark};
  font-variant-numeric: tabular-nums;
`;

const Divider = styled.span`
  color: ${inkLighter};
`;

const CacheNumber = styled.span`
  color: ${inkLight};
`;

const Dash = styled.span`
  color: ${skyDark};
`;
